
export const initSearchFund = (component) => {
	const showSearch = component.getAttribute('data-show-search') === 'true'
  // if search is set to no display. Hide it.
  if (!showSearch) {
    component
      .querySelector('.cmp-fund-list__search-field')
      .classList.add('d-none')
    return null
  }
}
